// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1oD_f","colCheckbox":"styles_colCheckbox__2S-2H"};